module.exports = "/_next/static/images/mobile-application-banner-78bb23bef9301568e6eaa42697b89d75.webp";